import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Colordiv from './colorDiv.js';
class Colors extends Component {
  constructor(props) {
       super(props);

       this.setWrapperRef = this.setWrapperRef.bind(this);
       this.handleClickOutside = this.handleClickOutside.bind(this);
   }

   componentDidMount() {
       document.addEventListener('mousedown', this.handleClickOutside);
   }

   componentWillUnmount() {
       document.removeEventListener('mousedown', this.handleClickOutside);
   }

   /**
    * Set the wrapper ref
    */
   setWrapperRef(node) {
       this.wrapperRef = node;
   }

   /**
    * Alert if clicked on outside of element
    */
   handleClickOutside(event) {
       if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
           //alert('You clicked outside of me!');
           this.props.outClick()
       }
   }
  render() {
    return (
      <div className="colors-levels" ref={this.setWrapperRef}>
        <Colordiv title="yellow" click={this.props.click}/>
        <Colordiv title="orange" click={this.props.click}/>
        <Colordiv title="purple" click={this.props.click}/>
        <Colordiv title="green" click={this.props.click}/>
        <Colordiv title="red" click={this.props.click}/>
        <Colordiv title="clear" click={this.props.click}/>
      </div>
    );
  }
}

export default withRouter(Colors);



// WEBPACK FOOTER //
// ./src/routes/Paitent/Colors.js